export default "__VITE_ASSET__p3t5N_DJ__"